const NHAN = {
  cho_xu_ly: { label: "Chờ xử lý", color: "secondary" },
  cho_ke_toan: { label: "Chờ kế toán", color: "warning" },
  dang_thanh_toan: { label: "Đang thanh toán", color: "info" },
  da_thanh_toan: { label: "Kế toán đã TT", color: "success" },
  loi: { label: "Lỗi chuyển khoản", color: "error" },
};

export function nhanTrangThaiThanhToan(trangThai) {
  return NHAN[trangThai] ?? { label: trangThai ?? "—", color: "secondary" };
}
